import { useSelector, useDispatch } from 'react-redux'
import isEmail from 'validator/lib/isEmail'

import { authenticate } from 'store/user/actions'
import { getLoginFormStrings } from 'store/strings/selectors'
import { LoginForm } from 'ui-component-library/components/OrderConfirmation/LoginOrCreateAccount'

type LoginFormSubmitParams = {
  email: string
  password: string
}

function LoginFormContainer() {
  const dispatch = useDispatch()
  const {
    emailText,
    passwordText,
    forgotPasswordText,
    buttonText,
    errorText,
  } = useSelector(getLoginFormStrings)

  function handleSubmit({ email, password }: LoginFormSubmitParams) {
    return new Promise<void>((resolve, reject) => {
      if (!isEmail(email) || !password) {
        reject(new Error('email and password required'))
      }

      return authenticate({ email, password })(dispatch)
        .then(resolve)
        .catch(reject)
    })
  }

  return (
    <LoginForm
      onSubmit={handleSubmit}
      errorText={errorText}
      emailText={emailText}
      passwordText={passwordText}
      buttonText={buttonText}
      forgotPasswordText={forgotPasswordText}
    />
  )
}

export default LoginFormContainer
